import { Injectable } from '@angular/core';
import { ApiClientService } from './util/api.client.service';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  constructor(public http: ApiClientService) { }

  searchApplicant(docNumber: string, sex: string) {
    return this.http.get(`/person/secure/applicant/${docNumber}/${sex}`);
  }
  searchApplicantByParams(docNumber: string, sex: string, date:string) {
    return this.http.get(`/person/applicant/${docNumber}/${sex}/${date}`);
  }

  infoByQR(sectionalItemRequestId: any) {
    return this.http.get(`/public/getQr/${sectionalItemRequestId}`)
  }
}
